module.exports = __webpack_public_path__ + "img/c1.ec80c493.png";